import React from 'react';
import styled, { css } from 'styled-components';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const ChartLoadingView = () => {
    return (
        <DayNightChartContainer>
            <GraphWrap>
                <BarChartWrap>
                    <BarChartItemContainer key='bar-chart-day-loading-ui' isNight={false}>
                        <BarChartLabel>
                            <AnimatedLoadingPlaceholder height='100%'  />
                        </BarChartLabel>
                        <BarChartHigh /> 
                    </BarChartItemContainer>
                    <BarChartItemContainer key='bar-chart-night-loading-ui' isNight={true}>
                        <BarChartLabel>
                            <AnimatedLoadingPlaceholder height='100%'  />
                        </BarChartLabel> 
                        <BarChartLow />
                    </BarChartItemContainer>
                </BarChartWrap>
                <ChartDayLabel>
                    <AnimatedLoadingPlaceholder height='90%'  />
                </ChartDayLabel>
            </GraphWrap>
        </DayNightChartContainer>
        
    );
};

const DayNightChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 190px;
    width: 184px;
`;

const GraphWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    font-size: 0;
    padding-top: 21px; 
`;

const BarChartWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    height: calc(100% - 27px);
`;

const ChartDayLabel = styled.div`
    height: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 7px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
`;

interface BarChartItemContainerProps {
    isNight: boolean;
}
const BarChartItemContainer = styled.div<BarChartItemContainerProps>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 40px;
    ${({ isNight }) => !isNight && `
        margin-right: 5px;
    `}
`;

const BarChartStyles = css`
    display: flex;
    content: '';
    width: 100%;
`;

const BarChartHigh = styled.div`
    ${BarChartStyles}
    background-color: rgba(255,255,255,0.5);
    height: 93%;
`;

const BarChartLow = styled.div`
    ${BarChartStyles}
    background-color: rgba(255,255,255,0.8);
    height: 63%;
`;

const BarChartLabel = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    height: 20px;
    color: #ffffff;
    margin-bottom: 1.5px;
`;